import React, { Component } from 'react'
import { Query } from 'react-apollo'
import VIDEO_UPLOADER_QUERY from './VideoUploader.query'
import { Form, withNotifier } from 'stylist'
import * as yup from 'yup'
import ProgressBar from 'components/ProgressBar'
import Uploader from 'components/Uploader'
import CreateVideoFromUuidMutation from 'mutations/CreateVideoFromUuid'
import { Redirect } from 'react-router-dom'

const schema = yup.object().shape({
  file: yup.mixed().required('File must be present')
})

class VideoUploader extends Component {
  render = () => (
    <Query query={VIDEO_UPLOADER_QUERY} variables={{ httpMethod: 'put' }}>
      {({ loading, data, error, notify, ...rest }) => {
        if (loading) {
          return null
        }

        if (!data || error) {
          throw new Error(error)
        }

        return (
          <CreateVideoFromUuidMutation
            uuid={data.signedUploadUrl.uuid}
            onCompleted={() => {
              this.props.notify(
                'success',
                'Your video has successfully uploaded, check back soon to view its highlights.',
                { sticky: true }
              )
              return <Redirect to="/videos" />
            }}
          >
            {createVideo => {
              return (
                <Uploader
                  url={data.signedUploadUrl.url}
                  onComplete={createVideo}
                >
                  {({ startUpload, progress, uploading }) => (
                    <Form
                      initialValues={{ file: null }}
                      validationSchema={schema}
                      onSubmit={({ file }) => startUpload(file)}
                    >
                      <Form.Title> Upload a Video </Form.Title>
                      <Form.Group>
                        <Form.FileUpload accept="video/mp4" name="file" />
                      </Form.Group>

                      <Form.Group buttons>
                        <Form.SubmitButton>Submit</Form.SubmitButton>
                      </Form.Group>
                      {uploading ? <ProgressBar progress={progress} /> : null}
                    </Form>
                  )}
                </Uploader>
              )
            }}
          </CreateVideoFromUuidMutation>
        )
      }}
    </Query>
  )
}

export default withNotifier(VideoUploader)



// WEBPACK FOOTER //
// ./src/routes/videos/components/VideoUploader.js